import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const benefits = [
  { icon: 'ri-wind-line', label: 'mente mais silenciosa', color: '#00C8E8' },
  { icon: 'ri-lungs-line', label: 'respiração mais calma', color: '#3DCC78' },
  { icon: 'ri-body-scan-line', label: 'corpo menos tenso', color: '#F5A520' },
  { icon: 'ri-shield-star-line', label: 'maior sensação de segurança interna', color: '#00C8E8' },
];

export default function PossibleBenefits() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-24 px-6" style={{ background: '#0B1525' }}>
      <div
        ref={ref}
        className="max-w-3xl mx-auto"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(28px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <div className="text-center mb-14">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-6 border"
            style={{ background: 'rgba(0,200,232,0.08)', color: '#00C8E8', borderColor: 'rgba(0,200,232,0.2)' }}
          >
            Após a sessão
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold text-white">
            O que você pode sentir após a sessão
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {benefits.map((b, i) => (
            <div
              key={b.label}
              className="flex items-center gap-4 rounded-2xl px-6 py-5 border"
              style={{
                background: '#0F1E30',
                borderColor: 'rgba(0,200,232,0.12)',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateX(0)' : 'translateX(-16px)',
                transition: `opacity 0.5s ease ${i * 0.1}s, transform 0.5s ease ${i * 0.1}s`,
              }}
            >
              <span
                className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
                style={{ background: `rgba(${b.color === '#00C8E8' ? '0,200,232' : b.color === '#3DCC78' ? '61,204,120' : '245,165,32'},0.1)` }}
              >
                <i className={`${b.icon} text-lg`} style={{ color: b.color }} />
              </span>
              <p className="text-base font-medium" style={{ color: '#B8D4E8' }}>{b.label}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm italic" style={{ color: '#5A7A95' }}>
          Não é mágica. É apenas o início de um processo de reorganização emocional.
        </p>
      </div>
    </section>
  );
}